import React, { useState, useEffect } from 'react';
import ProductList from './ProductList';
import Imgprdlist from '../images/product_list.png';


function ProductAll() {
    const [productAllAcne, SetProductAllAcne] = useState([]);
    const [productAllDerma, SetProductAllDerma] = useState([]);

    const [isAcne, setIsAcne] = useState(1);
    const [isDerma, setIsDerma] = useState(0);

    const SetAcneProduct = () => {
        let isDerma = 0;
        let isAcne = 1;

        setIsDerma(isDerma);
        setIsAcne(isAcne);
    };

    const SetDermaProduct = () => {
        let isDerma = 1;
        let isAcne = 0;

        setIsDerma(isDerma);
        setIsAcne(isAcne);

        //console.log(isDerma);
    };


    useEffect(() => {
        fetch('https://dev.jftheskinspecialist.com/api/allproductantiacne')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetProductAllAcne(datas.data);
        });

        fetch('https://dev.jftheskinspecialist.com/api/allproductderma')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetProductAllDerma(datas.data);
        });
    }, []);

    return (
        <div className="p-4 bg-[#fefaed]">
            <section class="py-10 text-center">
                <div class="mb-6" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <img src={Imgprdlist} alt="" />
                </div>

                {isAcne === 1 && (
                    <section class="py-0 text-center">
                        <div class="mb-6">
                            <h3 class="text-[#ff8e35] font-bold text-2xl inline-block border-b-4 border-[#ff8e35] pb-2">
                                ACNE SERIES
                            </h3>
                            <span class="text-lg font-bold mx-4">|</span>
                            <h3 class="text-lg font-bold inline-block" onClick={() => SetDermaProduct()}>DERMA SERIES</h3>
                        </div>

                        <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto">
                            <ProductList products={productAllAcne} />
                        </div>
                    </section>
                )}

                {isDerma === 1 && (
                    <section class="py-0 text-center">
                        <div class="mb-6">
                            <h3 class="font-bold text-lg inline-block" onClick={() => SetAcneProduct()}>ACNE SERIES
                            </h3>
                            <span class="text-lg font-bold mx-4">|</span>
                            <h3 class="text-[#ff8e35] text-2xl font-bold inline-block border-b-4 border-[#ff8e35] pb-2">DERMA SERIES</h3>
                        </div>
                        <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto">
                            <ProductList products={productAllDerma} />
                        </div>
                    </section>
                )}

            </section>
        </div>
    );
}

export default ProductAll;
